import { useCallback } from 'react';
import { useLocation } from 'react-router';
import useSweepNavigate from '../../../../navigation-utils/useSweepNavigate';
import { useSweepParams } from '../../../../navigation-utils/useSweepParams';
import { readableUUID } from '../../../../navigation-utils/readableUUID';

// const UUID_MATCH = /[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i;

/**
 * Custom hook that provides a function to navigate to a specific environment if appropriate.
 * It checks if the current route is a configuration canvas route and if so, it replaces the UUID in the path with the given `envId`.
 * The updated path is then navigated to using the `navigate` function from `useSweepNavigate`.
 */
export const useNavigateToEnv = () => {
  const { pathname, hash, search } = useLocation();
  const { crmOrgId: crmOrgIdFromParams } = useSweepParams<{ crmOrgId: string }>();
  const { navigate } = useSweepNavigate();

  const navigateToEnvIfAppropriate = useCallback(
    (envId: string) => {
      if (!envId || !crmOrgIdFromParams) return;
      if (envId === crmOrgIdFromParams) return;

      const isConfigurationCanvasRoute = Boolean(crmOrgIdFromParams);
      if (isConfigurationCanvasRoute) {
        let _newPath = pathname.replace(/\/[0-9a-z]+$/, `/${readableUUID(envId)}`);
        _newPath = `${_newPath}${search}${hash}`;

        navigate(_newPath);
      }
    },
    [crmOrgIdFromParams, hash, navigate, pathname, search],
  );

  return { navigateToEnvIfAppropriate };
};
